import { useBillingGateModel } from "@src/components/BillingSettings2026/workflow";
import { SMART_MERCHANDISING_ID } from "@src/constants/billing";
import { SETTINGS_ROUTES } from "@src/routes/routes";
import { SettingsSectionId } from "@src/types/navigation";

/**
 * Where to send a merchant who needs to upgrade for offers or onsite upsells.
 * Matches the destination the gated experience pages already use, so the
 * billing page opens with the right module pre-selected.
 */
export const MERCHANDISING_BILLING_HREF = `${SETTINGS_ROUTES.Settings}?selected=${SMART_MERCHANDISING_ID}#${SettingsSectionId.Billing}`;

/**
 * Whether offers and onsite upsells are locked behind an upgrade for this org.
 *
 * Both live on the Smart Merchandising module. This reads the same gate model
 * the pricing modal and gated experience pages use, so the AI surfaces can't
 * disagree with the rest of the app about what a merchant is entitled to.
 *
 * Returns `false` while the gate model is still loading, and for admins (whose
 * bypass the model already encodes) — the AI surfaces use this only to decide
 * whether to OFFER to build something, and the experience page's own
 * `ExperienceModuleGate` is what actually holds the line.
 */
export const useIsMerchandisingGated = (): boolean => {
  const gateModel = useBillingGateModel({ enabled: true });

  if (gateModel.status !== "ready") return false;

  return gateModel.byModuleId[SMART_MERCHANDISING_ID]?.kind === "gate";
};
